export const chartColorThreshold = (threshold, colorAbove, colorBelow) => (context) => {
    const index = context.dataIndex;
    const value = context.dataset.data[index];
    return value <= threshold
        ? colorBelow
        : colorAbove;
}